<template>
  <div class="body">
    <top-message></top-message>
    <div class="main">
      <div class="header">
        <div class="title">数据报表</div>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%"
        v-loading="loading"
      >
        <el-table-column
          label="省份"
        >
          <template slot-scope="scope">
            <span>江苏省</span>
          </template>
        </el-table-column>
        <el-table-column
          label="地方融资信用服务平台数"
        >
          <template slot-scope="scope">
            <span>1</span>
          </template>
        </el-table-column>
        <el-table-column
          label="平台名称"
        >
          <template slot-scope="scope">
            <span>全国融资信用服务平台(苏州站)</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createYear"
          label="层级"
        >
          <template slot-scope="scope">
            <span>地级市</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="institutionCount"
          label="入驻金融机构数(个)"
        >
        </el-table-column>
        <el-table-column
          prop="registeredCompanyCount"
          label="注册企业数(万家)"
        >
        </el-table-column>
        <el-table-column
          prop="totalLoanAmount"
          label="累计发放贷款额（亿元）"
        >
        </el-table-column>
        <el-table-column
          prop="totalCreditLoanAmount"
          label="其中：信用贷款（亿元）"
        >
        </el-table-column>
        <el-table-column
          prop="monthLoanAmount"
          label="当月发放贷款额（亿元）"
        >
        </el-table-column>
        <el-table-column
          prop="monthCreditLoanAmount"
          label="其中：信用贷款（亿元）"
        >
        </el-table-column>
        <el-table-column
          prop="totalPrivateCompanyCount"
          label="累计注册民营企业数量（万家）"
        >
        </el-table-column>
        <el-table-column
          prop="totalLoanPrivateCompanyCount"
          label="累计获得贷款民营企业数量（万家）"
        >
        </el-table-column>
        <el-table-column
          prop="totalPrivateLoanAmount"
          label="累计发放民营企业贷款额（亿元）"
        >
        </el-table-column>
        <el-table-column
          prop="totalPrivateCreditLoanAmount"
          label="其中：信用贷款（亿元）"
        >
        </el-table-column>
        <el-table-column
          prop="monthLoanPrivateCompanyCount"
          label="当月获得贷款民营企业数量（万家）"
        >
        </el-table-column>
        <el-table-column
          prop="monthPrivateLoanAmount"
          label="当月发放民营企业贷款额（亿元）"
        >
        </el-table-column>
        <el-table-column
          prop="monthPrivateCreditLoanAmount"
          label="其中：信用贷款（亿元）"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button v-loading="loading2" type="primary" @click="xiazai(scope.row)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
      
    </div>
  </div>
</template>
<script>
import { selectReportData } from '@/api/statistics'
import TopMessage from '../TopMessage.vue'
export default {
  data () {
    return {
      tableData: [],
      loading: false,
      loading2: false,
    }
  },
  components: {
    TopMessage
  },
  created () {
    this.getExecute()
  },
  methods: {
    xiazai () {
      this.loading2 = true
      const xhr = new XMLHttpRequest();
      let date = new Date()
      let year = date.getFullYear()
      let month = String(date.getMonth() + 1).padStart(2, '0');
      let dateday = year +'' + month
      xhr.open("post", this.baseUrl + "api/v1/report/exportReportData" , true);  // get、post都可

      xhr.responseType = "blob";  // 转换流
      xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8")
      xhr.onload = () => {
        if (xhr.status === 200) {
          const blob = xhr.response;
          const fileName = dateday + ".xlsx";
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            const a = document.createElement("a")
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click()
            window.URL.revokeObjectURL(url)
          }
        }
        this.loading2 = false
      }
      xhr.onerror = () => {
        this.loading2 = false
        this.$message.error("下载失败")
      }
      xhr.send(JSON.stringify({date: dateday}));
    },
    getExecute () {
      this.loading = true
      let date = new Date()
      let year = date.getFullYear()
      let month = String(date.getMonth() + 1).padStart(2, '0');
      let dateday = year +'' + month
      selectReportData({date: dateday}).then(res => {
        console.log(res)
        if (res.data.code == 200) {
          this.tableData = [res.data.data.data]
          this.loading = false
        }
      }).catch(err => { })
    },
  }
}
</script>
<style >
.my-info-dialog .el-dialog__body {
  background-color: #f2f2f2;
}
.my-info-dialog .el-dialog__header {
  display: none;
}
.el-table .warning-row {
  background: #fff9f8;
}

.el-table .success-row {
  background: #fff;
}
</style>
<style lang='less' scoped>
.body {
  width: 100%;
  min-height: 800px;

  .main {
    width: 100%;
    min-height: 800px;
    background-color: #fff;
    margin-top: 15px;
    border-radius: 4px;
    padding-top: 27px;

    .header {
      font-size: 24px;
      font-family: Alibaba PuHuiTi;
      font-weight: 500;
      color: #2981ee;
      border-left: 8px solid #2981ee;
      padding-left: 27px;
      margin-bottom: 20px;
    }
    /deep/ .el-table th > .cell {
      text-align: center;
      color: #252525;
    }
    /deep/ .el-table th.is-leaf {
      border: none;
      background: #f3f4f9;
    }
    /deep/ .el-table td {
      border: none;
    }
    /deep/ .el-table .cell {
      text-align: center;
    }
  }
  .dlgheader {
    width: 100%;
    background-color: #f2f2f2;

    .toptitle {
      font-size: 26px;
      font-family: Alibaba PuHuiTi;
      font-weight: 500;
      color: #000000;
      text-align: center;
    }
    .template {
      width: 588px;
      height: 136px;
      background: #d9ece1;
      border-radius: 2px;
      margin-left: 25px;
      margin-top: 28px;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: space-evenly;
      .financing {
        display: flex;
        align-items: center;
        img {
          margin-right: 8px;
        }
      }
    }
    .type {
      width: 588px;
      height: 280px;
      background: #ffffff;
      border: 1px solid #d4d4d7;
      border-radius: 2px;
      margin-left: 25px;
      margin-top: 21px;
      box-sizing: border-box;
      padding: 28px 38px;
      .top {
        width: 100%;
        height: 65px;
        border-bottom: 1px solid #dedee0;
        display: flex;
        .a {
          font-size: 24px;
          font-family: Alibaba PuHuiTi;
          font-weight: 600;
          color: #f85b4b;
          margin-top: 8px;
          margin-left: 37px;
        }
        .b {
          font-size: 18px;
          font-family: Alibaba PuHuiTi;
          font-weight: 500;
          color: #2a2a2a;
          margin-top: 8px;
        }
      }
      .middle {
        height: 114px;
        width: 100%;
        border-bottom: 1px solid #dedee0;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        flex-direction: column;
        .c {
          font-size: 20px;
          font-family: Alibaba PuHuiTi;
          font-weight: 500;
          color: #2a2a2a;
          display: flex;
        }
        .d {
          display: flex;
          .a {
            font-size: 24px;
            font-family: Alibaba PuHuiTi;
            font-weight: 600;
            color: #f85b4b;
          }
          .b {
            font-size: 18px;
            font-family: Alibaba PuHuiTi;
            font-weight: 500;
            color: #a2a4ac;
            margin-left: 5px;
          }
        }
      }
      .btn {
        width: 100%;
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .button {
      width: 100%;
      margin-top: 34px;
      display: flex;
      justify-content: space-evenly;
      .cancel {
        width: 140px;
        height: 44px;
        background: #f3f4f9;
        border: 1px solid #a2a4ac;
        border-radius: 8px;
      }
      .midden {
        width: 140px;
        height: 44px;
        background: #ddecff;
        border: 1px solid #2981ee;
        border-radius: 8px;
        font-size: 20px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: #2981ee;
        line-height: 18px;
      }
      .last {
        width: 140px;
        height: 44px;
        background: #2981ee;
        border: 1px solid #2981ee;
        border-radius: 8px;
        font-size: 20px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }
  .loading {
    display: flex;
    align-items: center;
    flex-direction: column;
    .top {
      width: 54px;
      height: 56px;
    }
  }
}
</style> 
<style lang="less">
.myMonth {
  .el-date-picker__header {
    display: none;
  }
}
</style>